import { render, staticRenderFns } from "./ModalExibicaoMultiplasNdsCamelCase.vue?vue&type=template&id=c3dbad8c"
import script from "./ModalExibicaoMultiplasNdsCamelCase.vue?vue&type=script&lang=js"
export * from "./ModalExibicaoMultiplasNdsCamelCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports